export default "__VITE_ASSET__DfIn0ORh__"